/* unplugin-vue-components disabled */import { render } from "./SelectCategory.vue?vue&type=template&id=19789566&scoped=true&ts=true"
import script from "./SelectCategory.vue?vue&type=script&lang=ts"
export * from "./SelectCategory.vue?vue&type=script&lang=ts"

import "./SelectCategory.vue?vue&type=style&index=0&id=19789566&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19789566"]])

export default __exports__